import { InputBuscadorContainer } from "./localStyle";

const InputBuscador = ({ value }) => {
  const formattedValue = value && value?.replace(/ /g, "\u00a0"); 
  return (
    <InputBuscadorContainer>
      <div className="input">
        {formattedValue}
        <span className={`cursor`}></span>
      </div>
    </InputBuscadorContainer>
  );
};

export default InputBuscador;
